<template>
  <div class="leftres">
    <div>
      <div :class=" showorhide ? 'inputtop' : 'inputtops' ">
        <div v-for="(item , index) of formdata"  :key="index" style="display: inline-block;">
          <Commondropdownlist ref="select" :lablewith="item.lablewith" :options="item.options" :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" @cascaderchange="cascaderchange"></Commondropdownlist>
        </div>
        <div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
          <CommonBtngroup :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
        </div>
        <div style="height:10px;">
        </div>
      </div>
      <div class="TableBox" style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px;background-color: #FFFFFF;">
        <Departmentmanagementtable :tableData="tabledata"></Departmentmanagementtable>
      </div>
    </div>
  </div>
</template>

<script>
import Commondropdownlist from '../../components/common-dropdownlist.vue'
import CommonBtngroup from '../../components/commongroup.vue'
import Departmentmanagementtable from '../departmentmanagement/components/departmentmanagementtable.vue'
import { GetMenusWithAuthorites, OrganizationList } from '@/api/home'
export default {
  components: {
    Commondropdownlist,
    CommonBtngroup,
    Departmentmanagementtable
  },
  data() {
    return {
      showorhide: true,
      formdata: [
        {
          inputdata: "",
          title: '上级组织代码',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: '',
          inputtype: 'input',
          width: '230px',
          NodeID: '',
          options: [
          ],
          lablewith: "120px",
        },
        {
          inputdata: "",
          title: '组织名称',
          fontSize: '14px',
          color: '#333333',
          placeholder: '请输入',
          types: 'text',
          inputtype: 'input',
          width: '230px'
        },
        {
          inputdata: "",
          title: '是否启用',
          fontSize: '14px',
          color: '#333333',
          placeholder: '全部',
          types: '',
          inputtype: 'select',
          width: '240px',
          options: [
            {
              value: '全部',
              key: ''
            }, {
              value: '启用',
              key: '1'
            }, {
              value: '停用',
              key: '2'
            },
          ]
        },
      ],
      tabledata: [],
      zname: "",
      type: "",
      parentId: "",
    }
  },
  mounted() {
    // this.getMenusWithAuthorites()
    // let e = this.$refs.select
    //console.log("ssss")
    // //console.log(e,"ss")

    this.organizationList()
  },
  methods: {
    // async getMenusWithAuthorites() {
    //   let {
    //     code,
    //     data
    //   } = await GetMenusWithAuthorites({

    //   })
    //   if (code == 0) {
    //     this.formdata[0].options = data
    //   }
    // },

    async organizationList() {
      let list = await OrganizationList({
        name: this.zname,
        type: this.type,
        parentId: this.parentId,
        pageSize: 20,
        pageIndex: 0
      })
      if (list.code == 0) {
        this.tabledata = list.data.data
      }
      //console.log("list", list.data.data)
    },
    reset() {
      this.$refs.select.map((item, index) => {
        item.modelvalue = ''
      })
      this.dialogVisibles = true
    },
    hide() {
      this.showorhide = false
      //console.log("askdas", this.showorhide)

    },
    showclick() {
      this.showorhide = true
    },
    select() {
      try {
        let e = this.$refs.select
        this.parentId = e[0].modelvalue
        this.zname = e[1].modelvalue
        this.type = e[2].modelvalue
        this.organizationList()
      } catch (error) {
        this.organizationList()
      }
    },
    cascaderchange(e) {
      this.NodeID = e[e.length - 1]
      //console.log(e[e.length - 1], "e")
    },
  }
}
</script>

<style lang="less" scoped>
.inputtop {
  width: 980px;
  height: 10px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 15px;
  padding-bottom: 70px;
  transition: all .3s;
  overflow: hidden;
}
.inputtops {
 width: 980px;
  height: 0px;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding-top: 9px;
  padding-bottom: 64px;
  overflow: hidden;
  position: relative;
 transition: all .3s;
}
.Btngroup {
  display: inline-block;
  float: right;
  margin-right: 0px;
  width: 300px;
  height: 50px;
  background-color: #ffffff;
  position: relative;
  bottom: 45px;
}
.Btngroups {
  display: inline-block;
  float: right;
  margin-top: 5px;
  margin-right: 0px;
}

</style>